import moment from "moment";

import { PROMO_DEFAULT_LANG } from "../components/promo/copy";

/*
  Campaign: "Your Business. Your Vehicles. Your workflows."
  Custom GPS + business automation, from QAR 379 / month.

  Two surfaces, both switched off automatically after OFFER_END:
    - a permanent sticky bar at the top of every /app page
    - a popup that returns at most once every POPUP_INTERVAL_HOURS
*/

export const OFFER_START = "2026-08-21";
export const OFFER_END = "2026-09-20"; // inclusive — last day the offer is shown

export const POPUP_STORAGE_KEY = "promo_gps379_last_shown";
export const POPUP_INTERVAL_HOURS = 12;

/* The ad keeps its own language, separate from the platform. The app stays
   English by default; the ad opens in Arabic and remembers whatever the
   viewer picks on its own switcher. */
export const LANG_STORAGE_KEY = "promo_gps379_lang";

export const readPromoLang = () => {
  try {
    const stored = localStorage.getItem(LANG_STORAGE_KEY);
    return stored === "en" || stored === "ar" ? stored : PROMO_DEFAULT_LANG;
  } catch (e) {
    return PROMO_DEFAULT_LANG;
  }
};

export const writePromoLang = (lang) => {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch (e) {}
};

export const WHATSAPP_NUMBER = "97430126301";
export const WHATSAPP_DISPLAY = "+974 3012 6301";

/* The pre-typed message doubles as the campaign tracker: every lead arrives
   with the same opening line, so replies are countable in WhatsApp without
   any analytics work. Kept brand-neutral because the app is white-labelled
   per subscriber. No apostrophes - these are plain strings, but the display
   copy lives in lang/locales/*.js where an apostrophe would need ICU escaping. */
const WHATSAPP_MESSAGE = {
  en: "Hello, I am interested in the custom GPS plan at QAR 379/month.",
  ar: "مرحباً، أرغب في معرفة المزيد عن خطة تتبّع GPS المخصّصة بسعر 379 ر.ق شهرياً.",
};

export const whatsAppLink = (lang) => {
  const message = WHATSAPP_MESSAGE[lang] || WHATSAPP_MESSAGE[PROMO_DEFAULT_LANG];

  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

/* Arabic uses a numeric date on purpose: month names would mean loading
   moment/locale/ar, and moment sets the *global* locale as a side effect of
   defining one, which would switch every other date in the app to Arabic. */
export const offerEndText = (lang) =>
  lang === "ar"
    ? moment(OFFER_END).format("DD/MM/YYYY")
    : moment(OFFER_END).format("D MMM YYYY");

export const isOfferActive = () => {
  const now = moment();
  return (
    now.isSameOrAfter(moment(OFFER_START).startOf("day")) &&
    now.isSameOrBefore(moment(OFFER_END).endOf("day"))
  );
};

// True when the popup has never been shown, or was last shown 12+ hours ago.
export const shouldShowOfferPopup = () => {
  if (!isOfferActive()) {
    return false;
  }

  try {
    const lastShown = localStorage.getItem(POPUP_STORAGE_KEY);

    if (!lastShown) {
      return true;
    }

    const hoursSince = moment().diff(moment(Number(lastShown)), "hours", true);

    return hoursSince >= POPUP_INTERVAL_HOURS;
  } catch (e) {
    // private mode / storage disabled — show it, just don't remember
    return true;
  }
};

// Called both when the popup opens and when it is dismissed, so the
// 12 hour window starts from the last time the user actually saw it.
export const markOfferPopupShown = () => {
  try {
    localStorage.setItem(POPUP_STORAGE_KEY, String(Date.now()));
  } catch (e) {}
};
